var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 813.95 17.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Podere Colle San Massimo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LATERALI"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-footer-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-footer-2",
    x: 217.83,
    y: 10.83,
    width: 1.65,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-footer-2",
    x: 207,
    y: 14.12,
    width: 6.61,
    height: 1.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-footer-2",
    x: 208.65,
    y: 1.65,
    width: 4.95,
    height: 1.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-footer-2",
    x: 217.83,
    y: 1.65,
    width: 6.6,
    height: 4.95
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-footer-2",
    points: "216.18 0 215.25 0 215.25 4.95 208.65 4.95 208.65 8.26 207 8.26 207 9.18 215.25 9.18 215.25 10.83 208.65 10.83 208.65 12.48 215.25 12.48 215.25 17.43 216.18 17.43 216.18 9.18 224.43 9.18 224.43 8.26 216.18 8.26 216.18 0"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-footer-2",
    x: 221.13,
    y: 10.83,
    width: 1.65,
    height: 6.6
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-footer-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-footer-2",
    x: 427.94,
    y: 10.83,
    width: 1.66,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-footer-2",
    x: 417.12,
    y: 14.12,
    width: 6.6,
    height: 1.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-footer-2",
    x: 418.77,
    y: 1.65,
    width: 4.95,
    height: 1.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-footer-2",
    x: 427.94,
    y: 1.65,
    width: 6.6,
    height: 4.95
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-footer-2",
    points: "426.29 0 425.37 0 425.37 4.95 418.77 4.95 418.77 8.26 417.12 8.26 417.12 9.18 425.37 9.18 425.37 10.83 418.77 10.83 418.77 12.48 425.37 12.48 425.37 17.43 426.29 17.43 426.29 9.18 434.54 9.18 434.54 8.26 426.29 8.26 426.29 0"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-footer-2",
    x: 431.24,
    y: 10.83,
    width: 1.65,
    height: 6.6
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-footer-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-footer-2",
    x: 568.25,
    y: 10.83,
    width: 1.65,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-footer-2",
    x: 557.43,
    y: 14.12,
    width: 6.6,
    height: 1.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-footer-2",
    x: 559.07,
    y: 1.65,
    width: 4.96,
    height: 1.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-footer-2",
    x: 568.25,
    y: 1.65,
    width: 6.61,
    height: 4.95
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-footer-2",
    points: "566.6 0 565.68 0 565.68 4.95 559.07 4.95 559.07 8.26 557.43 8.26 557.43 9.18 565.68 9.18 565.68 10.83 559.07 10.83 559.07 12.48 565.68 12.48 565.68 17.43 566.6 17.43 566.6 9.18 574.85 9.18 574.85 8.26 566.6 8.26 566.6 0"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-footer-2",
    x: 571.55,
    y: 10.83,
    width: 1.66,
    height: 6.6
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-footer-2",
    d: "M3.46,17.56H0V.24H17.32V10.63H3.46ZM13.85,7.17V3.7H3.46V7.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-footer-2",
    d: "M34.64,17.56V.24H52V17.56Zm13.85-3.47V3.7H38.1V14.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-footer-2",
    d: "M69.27,17.56V.24H83.13L86.59,3.7V14.09l-3.46,3.47Zm3.47-3.47h8.65l1.74-1.73V5.6L81.39,3.7H72.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-footer-2",
    d: "M107.37,10.63v3.46h13.86v3.47H103.91V.24h17.32V3.7H107.37V7.17h10.39v3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-footer-2",
    d: "M145.47,10.63H142v6.93h-3.47V.24h17.32V10.63h-6.11l6.11,6.93h-4.27ZM142,3.7V7.17H152.4V3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-footer-2",
    d: "M176.64,10.63v3.46H190.5v3.47H173.18V.24H190.5V3.7H176.64V7.17H187v3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-footer-2",
    d: "M242.45.24h17.32V3.7H245.92V14.09h13.85v3.47H242.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-footer-2",
    d: "M277.09,17.56V.24h17.32V17.56Zm13.85-3.47V3.7H280.55V14.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-footer-2",
    d: "M329,17.56H311.72V.24h3.47V14.09h10.39V10.63H329Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-footer-2",
    d: "M363.68,17.56H346.36V.24h3.46V14.09h10.39V10.63h3.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-footer-2",
    d: "M384.46,10.63v3.46h13.85v3.47H381V.24h17.31V3.7H384.46V7.17h10.39v3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-footer-2",
    d: "M467.59,3.7H453.73V7.17h13.86V17.56H450.27V14.09h13.85V10.63H450.27V.24h17.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-footer-2",
    d: "M493.56,17.56V14.09h3.36l-3.36-8.66-4.7,12.13h-4L491.83.24h3.47l6.92,17.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-footer-2",
    d: "M519.54,17.56V.24H523l10.4,12.28V.24h3.46V17.56H533.4L523,5.65V17.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-footer-2",
    d: "M588.81,17.56V.24h17.32V17.56h-3.46V3.7H599.2V17.56h-3.46V3.7h-3.46V17.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-footer-2",
    d: "M632.11,17.56V14.09h3.35l-3.35-8.66L627.4,17.56h-3.95L630.38.24h3.46l6.93,17.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-footer-2",
    d: "M675.4,3.7H661.55V7.17H675.4V17.56H658.08V14.09h13.86V10.63H658.08V.24H675.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-footer-2",
    d: "M710,3.7H696.18V7.17H710V17.56H692.72V14.09h13.86V10.63H692.72V.24H710Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-footer-2",
    d: "M737.75.24V17.56h-3.47V.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-footer-2",
    d: "M762,17.56V.24h17.32V17.56h-3.46V3.7h-3.47V17.56h-3.46V3.7h-3.46V17.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-footer-2",
    d: "M796.63,17.56V.24H814V17.56Zm13.85-3.47V3.7H800.09V14.09Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/logo-footer.4bf50708ab52a948cbed09920eae3aed.svg";
export { ForwardRef as ReactComponent };